const mutations = {
    setLaborCostList(state, data) {
        state.laborCosts = data;
    },
    resetLaborCost(state) {
        state.labor = {
            description: '',
            cost: '',
            serviceId : null,
            serviceCategoryId : null,
        }
    },
    setlaborCost(state, data) {
        state.labor = data;
        if (data.service && data.service.serviceCategoryId) {
            state.labor.serviceCategoryId = data.service.serviceCategoryId;
        }
        state.labor.serviceId = data.serviceId;
    }
}

export default mutations;